import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UiActions } from './ui.actions';
import { selectSidenavOpen, selectGlobalLoading } from './ui.selectors';

/**
 * UI Facade
 * 
 * Provides a clean API for components to interact with UI state.
 * Encapsulates NgRx implementation details.
 */
@Injectable()
export class UiFacade {
  
  // ========== Sidenav Observables ==========
  
  /**
   * Observable of sidenav open state
   */
  readonly sidenavOpen$: Observable<boolean>;
  readonly globalLoading$: Observable<boolean>;
  
  constructor(private store: Store) {
    this.sidenavOpen$ = this.store.select(selectSidenavOpen);
    this.globalLoading$ = this.store.select(selectGlobalLoading);
  }
  
  // ========== Sidenav Methods ==========
  
  /**
   * Toggle sidenav open/closed state
   */
  toggleSidenav(): void {
    this.store.dispatch(UiActions.toggleSidenav());
  }
  
  /**
   * Open the sidenav
   */
  openSidenav(): void {
    this.store.dispatch(UiActions.openSidenav());
  }
  
  /**
   * Close the sidenav
   */
  closeSidenav(): void {
    this.store.dispatch(UiActions.closeSidenav());
  }

  showGlobalLoading(): void {
    this.store.dispatch(UiActions.showGlobalLoading());
  }

  hideGlobalLoading(): void {
    this.store.dispatch(UiActions.hideGlobalLoading());
  }
}
